export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/zh-cn.lyaml"));
at({ "zh-cn": { "public": { "sampleString": "\u793A\u4F8B\u5B57\u7B26\u4E32" } } });
};